import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisListHrisIntegrationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HrisListHrisIntegrationsQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, org?: { __typename?: 'Org', id: number, hrisIntegrations: Array<{ __typename?: 'HrisIntegration', id: string, type: Types.HrisIntegrationType, createdAt: string, hrisProvider?: string | null, initialSyncCompletedAt?: string | null, status?: Types.MergeLinkedAccountStatus | null, statusDetail?: string | null, lastReceivedDataAt?: string | null, activeHrisEmployeeCount: number, locationCount: number, teamCount: number }> } | null } } | null };

export type ResyncHrisIntegrationMutationVariables = Types.Exact<{
  input: Types.ResyncHrisIntegrationInput;
}>;


export type ResyncHrisIntegrationMutation = { __typename?: 'Mutation', resyncHrisIntegration: { __typename?: 'ResyncHrisIntegrationMutationResult', success: boolean } };

export type DeleteHrisIntegrationMutationVariables = Types.Exact<{
  input: Types.DeleteHrisIntegrationInput;
}>;


export type DeleteHrisIntegrationMutation = { __typename?: 'Mutation', deleteHrisIntegration: { __typename?: 'DeleteHrisIntegrationMutationResult', success: boolean } };

export type HrisListHrisIntegrationFragment = { __typename?: 'HrisIntegration', id: string, type: Types.HrisIntegrationType, createdAt: string, hrisProvider?: string | null, initialSyncCompletedAt?: string | null, status?: Types.MergeLinkedAccountStatus | null, statusDetail?: string | null, lastReceivedDataAt?: string | null, activeHrisEmployeeCount: number, locationCount: number, teamCount: number };

export const HrisListHrisIntegrationFragmentDoc = gql`
    fragment HrisListHrisIntegration on HrisIntegration {
  id
  type
  createdAt
  hrisProvider
  initialSyncCompletedAt
  status
  statusDetail
  lastReceivedDataAt
  activeHrisEmployeeCount
  locationCount
  teamCount
}
    `;
export const HrisListHrisIntegrationsDocument = gql`
    query HrisListHrisIntegrations {
  Me {
    user {
      id
      org {
        id
        hrisIntegrations {
          ...HrisListHrisIntegration
        }
      }
    }
  }
}
    ${HrisListHrisIntegrationFragmentDoc}`;

/**
 * __useHrisListHrisIntegrationsQuery__
 *
 * To run a query within a React component, call `useHrisListHrisIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisListHrisIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisListHrisIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHrisListHrisIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<HrisListHrisIntegrationsQuery, HrisListHrisIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisListHrisIntegrationsQuery, HrisListHrisIntegrationsQueryVariables>(HrisListHrisIntegrationsDocument, options);
      }
export function useHrisListHrisIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisListHrisIntegrationsQuery, HrisListHrisIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisListHrisIntegrationsQuery, HrisListHrisIntegrationsQueryVariables>(HrisListHrisIntegrationsDocument, options);
        }
export type HrisListHrisIntegrationsQueryHookResult = ReturnType<typeof useHrisListHrisIntegrationsQuery>;
export type HrisListHrisIntegrationsLazyQueryHookResult = ReturnType<typeof useHrisListHrisIntegrationsLazyQuery>;
export type HrisListHrisIntegrationsQueryResult = Apollo.QueryResult<HrisListHrisIntegrationsQuery, HrisListHrisIntegrationsQueryVariables>;
export const ResyncHrisIntegrationDocument = gql`
    mutation ResyncHrisIntegration($input: ResyncHrisIntegrationInput!) {
  resyncHrisIntegration(input: $input) {
    success
  }
}
    `;
export type ResyncHrisIntegrationMutationFn = Apollo.MutationFunction<ResyncHrisIntegrationMutation, ResyncHrisIntegrationMutationVariables>;

/**
 * __useResyncHrisIntegrationMutation__
 *
 * To run a mutation, you first call `useResyncHrisIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncHrisIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncHrisIntegrationMutation, { data, loading, error }] = useResyncHrisIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResyncHrisIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ResyncHrisIntegrationMutation, ResyncHrisIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncHrisIntegrationMutation, ResyncHrisIntegrationMutationVariables>(ResyncHrisIntegrationDocument, options);
      }
export type ResyncHrisIntegrationMutationHookResult = ReturnType<typeof useResyncHrisIntegrationMutation>;
export type ResyncHrisIntegrationMutationResult = Apollo.MutationResult<ResyncHrisIntegrationMutation>;
export type ResyncHrisIntegrationMutationOptions = Apollo.BaseMutationOptions<ResyncHrisIntegrationMutation, ResyncHrisIntegrationMutationVariables>;
export const DeleteHrisIntegrationDocument = gql`
    mutation DeleteHrisIntegration($input: DeleteHrisIntegrationInput!) {
  deleteHrisIntegration(input: $input) {
    success
  }
}
    `;
export type DeleteHrisIntegrationMutationFn = Apollo.MutationFunction<DeleteHrisIntegrationMutation, DeleteHrisIntegrationMutationVariables>;

/**
 * __useDeleteHrisIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteHrisIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHrisIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHrisIntegrationMutation, { data, loading, error }] = useDeleteHrisIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHrisIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHrisIntegrationMutation, DeleteHrisIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHrisIntegrationMutation, DeleteHrisIntegrationMutationVariables>(DeleteHrisIntegrationDocument, options);
      }
export type DeleteHrisIntegrationMutationHookResult = ReturnType<typeof useDeleteHrisIntegrationMutation>;
export type DeleteHrisIntegrationMutationResult = Apollo.MutationResult<DeleteHrisIntegrationMutation>;
export type DeleteHrisIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteHrisIntegrationMutation, DeleteHrisIntegrationMutationVariables>;